import { useMemo } from 'react';
import strings from '../account/strings.json';

// Get the current account id from env, fallback to 'ezzy-events'
const ACCOUNT_ID = process.env.REACT_APP_ACCOUNT_ID || 'ezzy-events';

// Helper to get nested value by path (e.g. 'auth.signInTitle')
function getByPath(obj: any, path: string) {
  return path
    .split('.')
    .reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      obj
    );
}

export function useStrings() {
  // Memoize the selected string set
  const stringSet = useMemo(() => {
    // Fallback to 'ezzy-events' if not found
    return (
      (strings as any)[ACCOUNT_ID] || (strings as any)['ezzy-events'] || {}
    );
  }, []);

  // Usage: t('auth.signInTitle')
  function t(path: string, fallback?: string): string {
    const value = getByPath(stringSet, path);
    return value !== undefined ? value : fallback || path;
  }

  return { t, strings: stringSet };
}
